import API, {APIRequestConfig} from "@irati/utils/services/API"
import authentication from "@irati/auth"
import {User} from "@irati/types"

import PBService from "@irati/utils/services"
import medicalErrorHandler from "./errors/medicalErrorHandler"
import errorCodes from "../errorCodes"
import getGender from "../helpers/getGender"
import endpoints from "../endpoints"

interface MedicalUser {
  email: string
  phoneNumber: string
  gender: string
  dob: string
}

class MedicalService extends PBService {
  create(medicalUser: MedicalUser) {
    const {uuid, businessId} = authentication.user()
    const {email, phoneNumber, gender, dob} = medicalUser

    const data = {
      userId: uuid,
      tenantId: businessId,
      email,
      phoneNumber,
      gender: getGender(gender),
      dateOfBirth: dob.split("-").reverse().join("/")
    }

    return API.post(endpoints.create(), data).then((res) => res.data)
  }

  getMedicalAccount(user: User, config: APIRequestConfig = {}) {
    API.sentryIgnoreError(config, [errorCodes.PBMEDResourceNotFound])
    return API.get(endpoints.getMedicalAccount(), config).then((res) => res.data)
  }

  textMeInstructions(user = authentication.user()) {
    const data = {userId: user.uuid}
    return API.post(`${endpoints.textMeInstructions()}`, data).then((res) => res.data)
  }

  getStats() {
    return API.get(endpoints.getStats()).then((res) => res.data)
  }

  getCsv(tenantId: string) {
    return API.get(`${endpoints.getCsv(tenantId)}`).then((res) => res.data)
  }

  resendMedicalWelcomeEmail(userUuid: string) {
    return API.post(endpoints.resendWelcomeEmail(), {userId: userUuid}).then((res) => res.data)
  }
}

const service = new MedicalService({errorHandlers: [medicalErrorHandler]})

export default service

export const create = service.create
export const getMedicalAccount = service.getMedicalAccount
export const textMeInstructions = service.textMeInstructions
export const getStats = service.getStats
export const getCsv = service.getCsv
export const resendMedicalWelcomeEmail = service.resendMedicalWelcomeEmail
